export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: "Do you sign NDA to protect your client's app ideas?",
    answer:
      "Yes! We prioritize the confidentiality of your <a href='https://www.konstantinfo.com/blog/mobile-app-ideas/'>app idea</a> from day one. We commit to sign an NDA before having a brief discussion about your <a href='https://www.konstantinfo.com/blog/custom-application-development/'>custom mobile app development</a> project. This ensures that your intellectual property and app idea remain secure.",
  },
  {
    question:
      "Why should I partner with Konstant Infosolutions for developing a mobile application?",
    answer:
      "As a leading <a href='https://www.konstantinfo.com/mobile-application-development'>mobile app development company</a> in the USA with 23+ years of industry experience and a team of 180+ tech experts, we have delivered disruptive mobile apps to clients globally. Our team holds experience of creating digital solutions for close-knit start-ups and Fortune 500 enterprises including IEEE, NASSCOM, United Nations, Volkswagen, and so on.",
  },
  {
    question: "Can you integrate AI into my existing mobile app or software?",
    answer:
      "Yes, and there is no need to replace everything from your existing app or software to make it AI-driven. We have expertise in <a href='https://www.konstantinfo.com/ai-development-company'>integrating AI</a> tech into existing solutions without impacting your existing solution. This saves businesses from the expense of rebuilding the new solution from the entire new tech stack.",
  },
  {
    question: "How can I track the progress of my app?",
    answer:
      "We implement a set of KPIs to manage the progress of your project. To ensure complete transparency, we set up progress management tools such as Jira. Our project managers also communicate with you during the ongoing project ensuring you are always updated about the status of your project.",
  },
  {
    question: "How do you approach developing a mobile app or software?",
    answer:
      `As a custom mobile app and <a href='https://www.konstantinfo.com/services'>software development company</a>, we follow a holistic step-by-step approach for developing digital solutions. Our client-focused <a href='https://www.konstantinfo.com/blog/app-development-process/'>app development process</a> ensures every stage of development aligns with your business goals. The approach includes: 
      <ul>
      <li>Requirement Gathering</li>
      <li>Design</li>
      <li>Development/Iteration</li>
      <li>Testing</li>
      <li>Deployment</li>
      <li>Maintenance</li>
      </ul>`,
  },
  {
    question:
      "For what industries do you offer mobile and software development services?",
    answer:
      "We cater to diverse industry needs including agriculture, healthcare, manufacturing, banking, retail, and education. Our team of developers understands industry regulations and compliance standards for creating tailored solutions for every business niche.",
  },
];
